import { useMemo } from 'react';
import { useSwiperSlide } from 'swiper/react';

export const useCurrentSlide = () => {
  const swiperSlide = useSwiperSlide();

  const isCurrentSlide = useMemo(() => {
    //if not, we are in a card
    if (!swiperSlide) return true;

    const { isActive, isVisible } = swiperSlide;
    return isActive && isVisible;
  }, [swiperSlide]);
  return isCurrentSlide;
};
